import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Single lightweight endpoint that powers the floating-button badge.
// The DM list + groups list both already carry per-conversation counts,
// but the floating badge needs an aggregate that's stable even when the
// widget is closed and the list endpoints aren't being polled.
export const useUnreadSummary = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["chatUnreadSummary", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/chat/unread/summary`);

      return (
        response.data || { totalUnread: 0, dmUnread: 0, groupUnread: 0 }
      );
    },
    refetchInterval: 10000,
    refetchOnWindowFocus: true,
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching unread summary" },
  });
};
